import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import { getConsent, setConsent } from "@/lib/cookieConsent";
import { Button } from "@/components/ui/button";

const CookieConsentBanner = () => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    // Defer rendering so the cookie banner doesn't become the LCP element.
    // The inline hero content in index.html will establish LCP first.
    const needsConsent = getConsent() === null;
    if (needsConsent) {
      const timer = setTimeout(() => setVisible(true), 150);
      return () => clearTimeout(timer);
    }
  }, []);

  useEffect(() => {
    const handler = () => setVisible(true);
    window.addEventListener("reset-consent", handler);
    return () => window.removeEventListener("reset-consent", handler);
  }, []);

  if (!visible) return null;

  const handleAccept = () => {
    setConsent("accepted");
    setVisible(false);
  };

  const handleDecline = () => {
    setConsent("declined");
    setVisible(false);
  };

  return (
    <div className="fixed bottom-0 inset-x-0 z-50 p-4 sm:p-6">
      <div className="mx-auto max-w-2xl rounded-xl border border-border bg-card shadow-lg p-4 sm:p-6 flex flex-col sm:flex-row items-start sm:items-center gap-4">
        <p className="text-sm text-muted-foreground flex-1">
          We use cookies and analytics to understand how visitors use our site and to improve your
          experience. You can learn more in our{" "}
          <Link
            to="/privacy"
            className="text-primary hover:text-primary/80 underline underline-offset-4"
          >
            Privacy Policy
          </Link>
          .
        </p>
        <div className="flex gap-2 shrink-0">
          <Button variant="outline" size="sm" onClick={handleDecline}>
            Decline
          </Button>
          <Button size="sm" onClick={handleAccept}>
            Accept
          </Button>
        </div>
      </div>
    </div>
  );
};

export default CookieConsentBanner;
